import React, { useState } from 'react';

function App() {
  const [text, setText] = useState('Hello, React!');

  const handleClick = () => {
    setText('You clicked the button!');
  };

  return (
    <div className='p-16'>
        <div className='mb-10 '>
        <text className='text-center mb-5'>
        <h1 className=''><b>Privacy Policy</b></h1>
        </text>
        <text>
            This Privacy Policy governs the manner in which Dispatcher.com
        collects, uses, maintains and discloses information collected from
        users (each a “User”) of the www.dispatcher.com website (“Site”).
        This privacy policy applies to the Site and all products and services
        offered by Dispatcher.com.
        </text>
        </div>

        <text className='text-center mb-5'>
        <h1><b>Personal Information</b></h1>
        </text>
        <text>
                We may collect personal information from Users in a variety of ways,
        including, but not limited to, when Users visit our site, register on the
        site, subscribe to the newsletter, respond to a survey, fill out a form,
        and in connection with other activities, services, features or
        resources we make available on our Site.
        Users may be asked for, as appropriate, name, email address, mailing
        address, phone number or credit card information. Users may,
        however, visit our Site anonymously. We will collect personal
        information from Users only if they voluntarily submit such
        information to us. Users can always refuse to supply personal
        information, except that it may prevent them from engaging in
        certain Site-related activities.
        </text>

        <text className='text-center mb-5'>
        <h1><b>Non-Personal Information</b></h1>
        </text>  
        <text>
                We may collect non-personal information about Users whenever
        they interact with our Site. Non-personal information may include the
        browser name, the type of computer and technical information about
        the User’s means of connection to our Site, such as the operating
        system and the internet service providers utilized and other similar
        information. 
        </text>

        <text className='text-center mb-5'>
        <h1><b>Web Browser Cookies</b></h1>
        </text>  
        <text>
                Our Site may use “cookies” to enhance User experience. A User’s
        web browser places cookies on their hard drive for record-keeping
        purposes and sometimes to track information about them. User may
        choose to set their web browser to refuse cookies, or to alert you
        when cookies are being sent. If they do so, note that some parts of
        the Site may not function properly. 
        </text>

        <text className='text-center mb-5'>
        <h1><b>How We Use Collected Information</b></h1>
        </text>  
        <text>
                Dispatcher.com may collect and use Users personal information for
        the following purposes:
        Mobile App Information: What We Collect and
        How We Use it
        When you download our driver app on a mobile device, you have the
        ability to give access to certain features on your device. Our
        application will allow the User to utilize their device's camera to take
        photos and attach related images from the device's photo library to
        tickets. In addition, the application will use GPS information from a
        phone to send a driver's location to the web application. Also, we will
        track a User's location in the foreground and background, as well as
        track their fine and course location. Please note that you can modify
        your settings at any time.
        </text>

        <text className='text-center mb-5'>
        <h1><b>How We Protect Your Information</b></h1>
        </text>  
        <text>
                We adopt appropriate data collection, storage and processing
        practices and security measures to protect against unauthorized
        access, alteration, disclosure or destruction of your personal
        information, username, password, transaction information and data
        stored on our Site.
        Sensitive and private data exchange between the Site and its Users
        happens over an SSL secured communication channel and is
        encrypted and protected with digital signatures.
        Sharing Your Personal Information
        We do not sell, trade, or rent Users’ personal information to others.

        We may share generic aggregated demographic information not
        linked to any personal information regarding visitors and users with
        our business partners, trusted affiliates and advertisers for the
        purposes outlined above. We may use third party service providers
        to help us operate our business and the Site or administer activities
        on our behalf, such as sending out newsletters or surveys.
        Changes to This Privacy Policy
        Dispatcher.com has the discretion to update this privacy policy at
        any time. When we do, we will revise the updated date at the top of
        this page. We encourage Users to frequently check this page for any
        changes to stay informed about how we are helping to protect the
        personal information we collect. You acknowledge and agree that it
        is your responsibility to review this privacy policy periodically and
        become aware of modifications. 
        </text>
        <div className='mt-10'>
        <text>
        Your Acceptance of These Terms
By using this Site, you signify your acceptance of this policy and
terms of service. If you do not agree to this policy, please do not use
our Site. Your continued use of the Site following the posting of
changes to this policy will be deemed your acceptance of those
changes.
Contacting Us
If you have any questions about this Privacy Policy, the practices of
this Site or your dealings with this Site, please contact us by email at
support@dispatcher.com or by filling out our contact form.
        </text>
        </div>
        <text>
            
        </text>
        <div>
        Last Updated: January 25, 2021.
        </div>
    </div>
  );
}

export default App;